import { ClientAppEvent } from "constants/index";

import type { PostHog } from "posthog-js";

import type { CarrierUpgradeSource } from "constants/index";

// Emits the unified upgrade-CTA event so every carrier upgrade entry point is
// attributable by `upgrade_source`. Callers pass the posthog instance from
// usePostHog() (may be undefined when no provider is mounted).
export function captureCarrierUpgradeCtaClicked(
  posthog: PostHog | undefined,
  upgradeSource: CarrierUpgradeSource,
  properties?: Record<string, unknown>,
): void {
  posthog?.capture(ClientAppEvent.CARRIER_UPGRADE_CTA_CLICKED, {
    upgrade_source: upgradeSource,
    ...properties,
  });
}
